const stakes = {
    title: 'Example JSON',
    expectedOutput: '343749.99999999994',
    initialDisplayedCode: `{
	"stakes": [{
		"stake": 1,
		"outcomeId": 100,
		"toWinInput": 100,
		"eachWaySelected": false,
		"type": "single"
	}],
    	"selectedTab": "single",`,
    moreCode: `
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100
	},
	{
		"id": 101,
		"odds": 1200
	}],
	"betOffers": [],
	"hasSelectedTeaser": false,
	"selectedReward": {}
}`,
};

export default stakes;
